import request from '../utils/request'

export default {
  // 获取所有套餐组
  findAllProduct(params) {
    return request.get('/api/product/product', { params })
  },
  
  // 根据ID获取套餐组
  findProductById(id) {
    return request.get(`/api/product/product/${id}`)
  },
  
  // 添加套餐组
  addProduct(product) {
    return request.post('/api/product/product', product)
  },
  
  // 更新套餐组
  updateProduct(id, product) {
    return request.put(`/api/product/product/${id}`, product)
  },
  
  // 修改套餐组状态
  productStatus(id, status) {
    return request.put(`/api/product/product/status/${id}`, { status })
  },

  // 获取该套餐组下的所有套餐项
  findAllProductItem(params) {
    return request.get('/api/product/item', { params })
  },

  // 根据ID获取套餐项
  findProductItemById(id) {
    return request.get(`/api/product/item/${id}`)
  },

  // 添加套餐项
  addProductItem(productItem) {
    return request.post('/api/product/item', productItem)
  },

  // 更新套餐项
  updateProductItem(id, productItem) {
    return request.put(`/api/product/item/${id}`, productItem)
  },

  // 修改套餐项状态
  productItemStatus(id, status) {
    return request.put(`/api/product/item/status/${id}`, { status })
  },

  // 一键生成标准套餐
  generateProduct(orgId) {
    return request.put(`/api/product/generate/${orgId}`)
  },

  // 分配设备
  assignTargets(productId, targetIds) {
    return request.post(`/api/product/${productId}/targets`, targetIds)
  },

}